export default class ApplicantModel {
    constructor({ id, id_career, positions, name, email, phone, cv, status, tanggal }) {
        this.id = id;
        this.id_career = id_career;
        this.positions = positions;
        this.name_aplicant = name;
        this.email = email;
        this.no_hp = phone;
        this.cv = cv;
        this.status = status;
        this.tanggal = tanggal
    }
}